import * as workInformationReducer from "../reducers/workInformationReducer";

export const { getMineWorkInformations } = workInformationReducer;
